import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrFormSelectListComponent } from './pr-form-select-list.component';
import { PrFormSelectListOptionComponent } from './pr-form-select-list-option/pr-form-select-list-option.component';
import { PrButtonModule } from '@app/components/pr-button/pr-button/pr-button.module';
import { PrLabelModule } from '@app/components/pr-label/pr-label.module';
import { PrIconModule } from '@app/components/pr-icon/pr-icon.module';
import { PrLoaderModule } from '@app/components/pr-loader/pr-loader.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [PrFormSelectListComponent, PrFormSelectListOptionComponent],
  imports: [
    CommonModule,
    PrButtonModule,
    PrLabelModule,
    PrIconModule,
    PrLoaderModule,
    TooltipModule,
  ],
  exports: [PrFormSelectListComponent, PrFormSelectListOptionComponent],
})
export class PrFormSelectListModule {}
